module.exports = __webpack_public_path__ + "assets/f73b31bae65fcefeaf308a13add597e1.mp3";